import { render, staticRenderFns } from "./CamposAdicionais.vue?vue&type=template&id=18037f3e&scoped=true"
import script from "./CamposAdicionais.vue?vue&type=script&lang=js"
export * from "./CamposAdicionais.vue?vue&type=script&lang=js"
import style0 from "./CamposAdicionais.vue?vue&type=style&index=0&id=18037f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18037f3e",
  null
  
)

export default component.exports